<template>
  <div class="shadow py-3 px-2 rounded border">
    <div class="d-flex justify-content-between small">
      <div class="font-weight-bold">
        <StatusTag class="mr-2" :status="item.get('status')" />
        {{ item.get('or_id') || '(no id)' }}
      </div>
      <div>{{ item.get('createdAt').toLocaleDateString() }}</div>
    </div>
    <el-divider />
    <div class="d-flex justify-content-between">
      <div>{{ deliveryAddressString }}</div>
    </div>
  </div>
</template>

<script>
import StatusTag from '../../../../components/atoms/StatusTag';
export default {
  name: 'OrderRequestOverviewEntry',
  components: { StatusTag },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    deliveryAddressString() {
      return `${this.item.get('deliveryAddress').get('country')}-${this.item
        .get('deliveryAddress')
        .get('zipCode')} ${this.item.get('deliveryAddress').get('city')}, ${this.item
        .get('deliveryAddress')
        .get('street')}`;
    },
  },
  methods: {},
};
</script>

<style scoped></style>
